/** @param {unknown} err */
export function formatApiError(err) {
  if (!err) return '요청에 실패했습니다';
  const msg = String(err?.message || err?.error_description || err?.error || err || '');
  const code = err?.code || err?.statusCode || err?.status;

  if (msg === 'OFFLINE' || msg.includes('OFFLINE')) {
    return '인터넷 연결을 확인해 주세요';
  }
  if (msg === 'LOGIN_REQUIRED' || msg.includes('LOGIN_REQUIRED')) {
    return '로그인이 필요합니다. 다시 로그인해 주세요';
  }
  if (/load failed|failed to fetch|networkerror|network request failed/i.test(msg)) {
    return '네트워크 오류입니다. 연결·Supabase 설정을 확인해 주세요';
  }
  if (code === 'PGRST205' || /could not find the table/i.test(msg)) {
    return '서버 기능이 아직 배포되지 않았습니다. 잠시 후 다시 시도해 주세요';
  }
  if (code === '23505' || /duplicate key|unique constraint/i.test(msg)) {
    return '이미 등록된 정보와 중복됩니다. 업체명·연락처를 바꿔 보세요';
  }
  if (/row-level security|permission denied|42501/i.test(msg)) {
    return '저장 권한이 없습니다. 다시 로그인하거나 관리자에게 문의해 주세요';
  }
  if (/insufficient_credit/i.test(msg)) {
    return '크레딧이 부족해서 처리할 수 없습니다. 크레딧을 충전한 후 다시 시도해 주세요';
  }
  return msg || '요청에 실패했습니다';
}
